import { Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';

export function ReusePendingObservable() {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;
    const pendingObservablePropertyName = `__pendingObservable${propertyKey}`;
    target[pendingObservablePropertyName] = null;

    descriptor.value = function (...args: any[]) {
      if (!target[pendingObservablePropertyName]) {
        const result: Observable<any> = originalMethod.apply(this, args);
        target[pendingObservablePropertyName] = result.pipe(
          share(),
          finalize(() => (target[pendingObservablePropertyName] = null)),
        );
      }

      return target[pendingObservablePropertyName];
    };
  };
}
